export default __webpack_public_path__ + "static/media/Sun.f1096237.svg";